import { RxComponent } from '../common/rx.component';

export class LoadingPage extends RxComponent {
    public status: string;

    constructor(val?: string) {
        super();
        this.status = val || 'loading';
    }

    loading() {
        this.status = 'loading';
    }

    ready() {
        this.status = 'ready';
    }

    error() {
        this.status = 'error';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/loading/loading.page.component.ts